/**
 * Mobile browser detection utilities for wallet connection flow.
 *
 * On mobile Safari/Chrome, Solana wallet extensions don't exist.
 * We detect this and redirect users to open the page inside
 * their wallet's in-app browser via universal links.
 */

/**
 * Detect if running inside a wallet's in-app browser (Phantom, Solflare).
 * These browsers include their name in the user agent string.
 * Note: Brave injects window.phantom.solana but is NOT a wallet in-app browser.
 */
export function isWalletInAppBrowser(): boolean {
    return /Phantom|Solflare/i.test(navigator.userAgent);
}

/**
 * Detect if running on a mobile device where we should show the
 * MobileWalletSheet (deep link + browser wallet picker).
 *
 * Returns true on mobile Safari, Chrome, Brave, etc.
 * Returns false on desktop or inside a wallet's in-app browser
 * (where the wallet auto-injects and standard connect works).
 */
export function isMobileBrowser(): boolean {
    if (!/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) return false;
    if (isWalletInAppBrowser()) return false;
    return true;
}
